import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M22 24H17V23.92C20.94 23.42 24 20.08 24 16.02C24 15.46 23.56 15.02 23 15.02C22.44 15.02 22 15.46 22 16.02C22 19.32 19.32 22.02 16 22.02C12.68 22.02 10 19.34 10 16.02C10 15.46 9.56 15.02 9 15.02C8.44 15.02 8 15.46 8 16.02C8 20.08 11.06 23.42 15 23.92V24H10C10 25 10 26.44 10 27C10 27.56 10 26 10 28H22C22 28 22 27.56 22 27C22 26.44 22 25 22 24Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M16 20.1C18.2 20.1 20 18.3 20 16.1V8C20 5.8 18.2 4 16 4C13.8 4 12 5.8 12 8V16.1C12 18.3 13.8 20.1 16 20.1Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }